const CONSENT_COOKIE = "cookie_consent_gopaperless";
const LANG_COOKIE = "cookie_accesslang_gopaperless";
const CONSENT_MAX_AGE = 60 * 60 * 24 * 180;

export const getConsent = () => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(CONSENT_COOKIE + "="));

  if (!match) return null;

  try {
    return JSON.parse(decodeURIComponent(match.split("=")[1]));
  } catch {
    return null;
  }
};

export const setConsent = (consent) => {
  document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(
    JSON.stringify(consent)
  )}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`;

  window.dispatchEvent(
    new CustomEvent("cookie-consent-changed", {
      detail: consent,
    })
  );
};

export const hasConsent = (category) => {
  const consent = getConsent();
  return !!consent?.[category];
};

export const getLanguageFromPath = () => {
  const match = window.location.pathname.match(/^\/(en|vi)(\/|$)/);
  return match ? match[1] : "en";
};

export const getAccessLang = () => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(LANG_COOKIE + "="));
  if (!match) return null;
  const value = decodeURIComponent(match.split("=")[1]);
  return value === "vi" || value === "en" ? value : null;
};

export const setAccessLang = (lang) => {
  if (lang !== "en" && lang !== "vi") return;
  document.cookie = `${LANG_COOKIE}=${encodeURIComponent(
    lang
  )}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`;
};

export const clearAccessLang = () => {
  document.cookie = `${LANG_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
};

export const persistAccessLang = (lang) => {
  if (hasConsent("functional")) {
    setAccessLang(lang);
  } else {
    clearAccessLang();
  }
};

export const persistAccessLangFromUrl = () => {
  if (!hasConsent("functional")) return;
  setAccessLang(getLanguageFromPath());
};

export const syncAccessLangWithConsent = (consent) => {
  if (consent?.functional) {
    setAccessLang(getLanguageFromPath());
  } else {
    clearAccessLang();
  }
};

export const switchLanguage = (language) => {
  persistAccessLang(language);
  const newPath = window.location.pathname.replace(
    /^\/(en|vi)/,
    `/${language}`,
  );
  window.location.href = `${newPath}${window.location.search}${window.location.hash}`;
};
